// Admin authentication utilities using Supabase Auth
import { isAdminAuthenticated as supabaseIsAuthenticated, logoutAdmin as supabaseLogout } from './supabaseAuth';

export async function isAdminAuthenticated() {
  // Clear any old localStorage sessions
  localStorage.removeItem('admin_auth');
  localStorage.removeItem('supabase_admin_session');
  localStorage.removeItem('simple_admin_session');

  return await supabaseIsAuthenticated();
}

export function logoutAdmin() {
  // Clear any legacy sessions
  localStorage.removeItem('admin_auth');
  localStorage.removeItem('supabase_admin_session');
  localStorage.removeItem('simple_admin_session');

  return supabaseLogout();
}

export function extendAdminSession() {
  // Supabase handles session refresh automatically
  return true;
}
